export default __webpack_public_path__ + "static/media/tour4.19e005a7.png";